import script from "./FaltasAvisadasModal.vue?vue&type=script&setup=true&lang=js"
export * from "./FaltasAvisadasModal.vue?vue&type=script&setup=true&lang=js"

import "./FaltasAvisadasModal.vue?vue&type=style&index=0&id=e16caa64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e16caa64"]])

export default __exports__